<template>
  <div>
    <h2 class="text-2xl font-bold text-center">Keep in touch</h2>
    <div class="lg:text-center text-m">
      <p class="pt-2">We wouldn’t want you to miss out on offers, exclusive deals and the latest information on products and services that are available to you from across Post Office Ltd and its subsidiaries.</p>
      <div class="pt-5">
        <p>Our Privacy Policy informs you about how we use your personal details for marketing and what to do if you change your mind. <a target="_blank" href="https://www.postoffice.co.uk/privacy" class="text-polred">Read our Privacy Policy here (opens in new tab)</a>.</p>
      </div>
      <div class="pt-5">
        <p>Please tick the boxes below to indicate how you'd prefer to receive these offers and we'll do the rest:</p>
      </div>
    </div>
    <div class="flex flex-col justify-center mt-4 text-lg lg:flex-row">
      <div class="py-2 m-1 text-center">
        <label @keypress.enter.prevent="$event.target.click" class="flex checkbox-label">
          <div tabindex="0" :class="{ 'bg-polgrey-dark border-polgrey-dark' : directMailOptIn == 'Y', }" class="bg-white border checkbox">
            <!-- Post -->
            <input v-model="directMailOptIn" true-value="Y" false-value="N" :aria-checked="`${directMailOptIn == 'Y'}`" type="checkbox" class="hidden">
            <TickIcon class="fill-current hidden w-6 h-6 pointer-events-none"/>
          </div>
          <span class="mr-2 select-none">Post</span>
        </label>
      </div>
      <div class="py-2 m-1 text-center">
        <label @keypress.enter.prevent="$event.target.click" class="flex checkbox-label">
          <div tabindex="0" :class="{ 'bg-polgrey-dark border-polgrey-dark' : textOptIn == 'Y', }" class="bg-white checkbox">
            <!-- Text -->
            <input v-model="textOptIn" true-value="Y" false-value="N" :aria-checked="`${textOptIn == 'Y'}`" type="checkbox" class="hidden">
            <TickIcon class="fill-current hidden w-6 h-6 pointer-events-none"/>
          </div>
          <span class="mr-2 select-none"> Text</span>
        </label>
      </div>
      <div class="py-2 m-1 text-center">
        <label @keypress.enter.prevent="$event.target.click" class="flex checkbox-label">
          <div tabindex="0" :class="{ 'bg-polgrey-dark border-polgrey-dark' : phoneOptIn == 'Y', }" class="bg-white checkbox">
            <!-- Phone -->
            <input v-model="phoneOptIn" true-value="Y" false-value="N" :aria-checked="`${phoneOptIn == 'Y'}`" type="checkbox" class="hidden">
            <TickIcon class="fill-current hidden w-6 h-6 pointer-events-none"/>
          </div>
          <span class="mr-2 select-none"> Phone</span>
        </label>
      </div>
      <div class="py-2 m-1 text-center">
        <label @keypress.enter.prevent="$event.target.click" class="flex checkbox-label">
          <div tabindex="0" :class="{ 'bg-polgrey-dark border-polgrey-dark' : emailOptIn == 'Y', }" class="bg-white checkbox">
            <!-- Email -->
            <input v-model="emailOptIn" true-value="Y" false-value="N" :aria-checked="`${emailOptIn == 'Y'}`" type="checkbox" class="hidden">
            <TickIcon class="fill-current hidden w-6 h-6 pointer-events-none"/>
          </div>
          <span class="mr-2 select-none"> Email</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

import TickIcon from '@/v2/assets/images/icons/select-tick.svg';
import { mapFields } from 'vuex-map-fields'
import mixins from '@/v2/mixins'

export default {
  name: 'KeepInTouch',
  mixins: [mixins],
  data() {
    return {}
  },
  computed : {
    ...mapFields([
      'person.marketingConsent.directMailOptIn',
      'person.marketingConsent.textOptIn',
      'person.marketingConsent.phoneOptIn',
      'person.marketingConsent.emailOptIn',
    ]),
    isSectionComplete() {
      return this.directMailOptIn, this.textOptIn, this.phoneOptIn, this.emailOptIn, Date.now()
    }
  },
  watch: {
    isSectionComplete: {
      immediate: true,
      async handler() {
        this.$nextTick(async () => {
          await this.$root.$emit(`keepInTouchComplete`, (this.directMailOptIn == 'Y' || this.textOptIn == 'Y' || this.phoneOptIn == 'Y' || this.emailOptIn == 'Y'))
        })
      }
    },
  },
  components: {
    TickIcon
  }
}
</script>